import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { API, FixedAspectRatioImageDTO, SingleFileUpload, UserDTO } from 'src/app/services/api/api';
import { UserService } from 'src/app/services/user.service';
import { Clipping } from '../model';

@Component({
  selector: 'image-upload',
  templateUrl: './image-upload.component.html',
  styleUrls: ['./image-upload.component.scss'],
  standalone: false,
})
export class ImageUploadComponent implements OnInit {
  isDragOver: boolean;

  @Input()
  uploading: boolean;

  @ViewChild('filePicker') filePicker: ElementRef<HTMLInputElement>;

  _image: any;
  get image(): FixedAspectRatioImageDTO {
    return this._image;
  }

  @Input()
  set image(value: FixedAspectRatioImageDTO) {
    this._image = value;

    if (this.image) {
      this.initialClipping = {
        clippingTLX: this.image?.clippingTLX,
        clippingTLY: this.image?.clippingTLY,
        clippingBRX: this.image?.clippingBRX,
        clippingBRY: this.image?.clippingBRY,
      };
    }
  }

  @Output()
  fileChange: EventEmitter<SingleFileUpload> = new EventEmitter<SingleFileUpload>();
  @Output()
  clippingChange: EventEmitter<Clipping> = new EventEmitter<Clipping>();
  @Output()
  deletePress: EventEmitter<void> = new EventEmitter<void>();

  initialClipping: Clipping;

  crop: boolean;
  user: UserDTO;
  clipping: Clipping;
  debounceTimer: ReturnType<typeof setTimeout> = null;

  constructor(
    private api: API,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    // this.refresh();
  }

  // refresh(): void {
  //   this.api.shared_User_retrieve().subscribe((res: UserDTO) => {
  //     this.user = res;
  //     this.image = this.user?.avatar;
  //     this.initialClipping = {
  //       clippingTLX: this.image?.clippingTLX,
  //       clippingTLY: this.image?.clippingTLY,
  //       clippingBRX: this.image?.clippingBRX,
  //       clippingBRY: this.image?.clippingBRY
  //     }
  //   });
  // }

  onClippingChange(clipping: Clipping): void {
    this.clipping = clipping;
    // if (this.clipping) {
    //   this.image.clippingTLX = this.clipping.clippingTLX;
    //   this.image.clippingTLY = this.clipping.clippingTLY;
    //   this.image.clippingBRX = this.clipping.clippingBRX;
    //   this.image.clippingBRY = this.clipping.clippingBRY;
    // }
  }

  updateImageDebounced(): void {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = setTimeout(() => {
      this.updateImage();
    }, 500);
  }

  apply() {
    this.updateImageDebounced();
  }

  cancel() {
    this.clipping = null;
    this.crop = false;
  }

  updateImage(): void {
    // this.api.shared_User_clipAvatar(this.image).subscribe((res: FixedAspectRatioImageDTO) => {
    //   this.cancel();
    //   this.refresh();
    // });
    this.clippingChange.emit(this.clipping);
    this.cancel();
  }

  get canUpload(): boolean {
    return true;
  }

  get canDelete(): boolean {
    return this.hasImg;
  }

  get hasImg(): boolean {
    return this.image ? true : false;
  }

  get isUploading(): boolean {
    return this.uploading;
  }

  dropHandler(event) {
    this.isDragOver = false;
    event.stopPropagation();
    event.preventDefault();
    if (event.dataTransfer.items) {
      for (let i = 0; i < event.dataTransfer.items.length; i++) {
        if (event.dataTransfer.items[i].kind === 'file') {
          const file = event.dataTransfer.items[i].getAsFile();
          if (this.checkFileValid(file)) {
            this.fileUpload(file);
            break;
          }
        }
      }
    } else {
      for (let i = 0; i < event.dataTransfer.files.length; i++) {
        const f = event.dataTransfer.files[i];
        if (this.checkFileValid(f)) {
          this.fileUpload(f);
          break;
        }
      }
    }
  }

  dragOverHandler(event) {
    event.stopPropagation();
    event.preventDefault();
  }

  checkFileValid(f: File) {
    return !(!f.type || f.type.length < 2) && f?.type?.toLowerCase().startsWith('image');
  }

  openFilePicker() {
    this.filePicker.nativeElement.click();
  }

  filePicked() {
    const files: FileList = this.filePicker.nativeElement.files;
    if (files && files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        const f = files[i];
        if (this.checkFileValid(f)) {
          this.fileUpload(f);
        }
      }
    }
    this.filePicker.nativeElement.value = '';
  }

  deleteMedium() {
    this.deletePress.emit();
  }

  fileUpload(f: File) {
    this.uploading = true;

    const singleFileUpload: SingleFileUpload = new SingleFileUpload();
    singleFileUpload.file = f;
    this.fileChange.emit(singleFileUpload);
    // this.api.shared_User_uploadAvatar(multipart).subscribe((res: FixedAspectRatioImageDTO) => {
    //   this.uploading = false;
    //   this.image = res;
    // }, error => {
    //   this.uploading = false;
    // });
  }

  getDragAndDropClasses() {
    if (this.canUpload && this.isDragOver) {
      return 'box-dragover';
    } else if (!this.hasImg && this.canUpload) {
      return 'box-dragdrop';
    }
  }
}
